<!--
  An error message with an optional link after it, e.g. a failed write
  that needs the Changeling GitHub App installed ("Install the Changeling
  App on <owner>", opening GitHub in a new tab).
-->
<script lang="ts">
  interface Props {
    text: string;
    link?: string | null;
    linkText?: string | null;
  }
  let { text, link = null, linkText = null }: Props = $props();
</script>

{text}{#if link}{' '}<a class="error-link" href={link} target="_blank" rel="noreferrer" data-external>{linkText || 'Install the Changeling App'} ↗</a>{/if}

<style>
  .error-link {
    color: inherit;
    font-weight: 650;
    text-decoration: underline;
    text-underline-offset: 3px;
    white-space: nowrap;
  }
</style>
